import React, { DependencyList, useCallback, useEffect } from 'react';

const CHECK_DELAY = 2500;
const MAX_CHECK_ITERATION = 50;

/**
 * Хук для использования `Schmetterling` в кач-ве рекламных баннеров
 * @param deps Сюда нужно передать хук `useMemo`, если необходимо следить за какими-либо переменными,
 *             прим. `useMemo(() => [val1, val2], [val1, val2])` будет отслеживать изменения `val1` и `val2` вызывая отрисовку баннеров
 */
export const useSchmetterling = (deps?: DependencyList) => {
  const timer = React.useRef<number>();
  const checkCount = React.useRef<number>(0);

  const createBanners = React.useCallback(() => {
    if (!window.Schmetterling) {
      return false;
    }
    const advBanners = document.querySelectorAll('*[data-schmetterling-id]');
    [...advBanners].forEach((advBanner) => {
      window.Schmetterling.create({
        element: advBanner,
        params: {
          platform: `${advBanner.getAttribute('data-schmetterling-id')}`,
        },
        onError: (error) => {
          console.error(error);
        },
      });
    });
    return true;
  }, []);

  const initScript = useCallback(() => {
    if (createBanners()) {
      return;
    }
    if (checkCount.current < MAX_CHECK_ITERATION) {
      checkCount.current += 1;
      clearTimeout(timer.current);
      timer.current = Number(setTimeout(initScript, CHECK_DELAY));
    }
  }, [createBanners]);

  useEffect(() => {
    initScript();
  }, [initScript, deps]);
};
